import { render } from "./clientChat.html?vue&type=template&id=4c98dd6a&scoped=true&ts=true&external"
import script from "./ClientChat.vue?vue&type=script&lang=ts"
export * from "./ClientChat.vue?vue&type=script&lang=ts"

import "./ClientChat.vue?vue&type=style&index=0&id=4c98dd6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c98dd6a"]])

export default __exports__